import 'dotenv/config'

const API_URL = process.env.API_URL
const GOOGLE_CAPTCHA_KEY = process.env.GOOGLE_CAPTCHA_KEY
const GIPHY_API_KEY = process.env.GIPHY_API_KEY
const PIN_IFRAME_URI = process.env.PIN_IFRAME_URI

export { API_URL, GOOGLE_CAPTCHA_KEY, GIPHY_API_KEY, PIN_IFRAME_URI }
